<div class="element" fxLayout="row">
  
  <!-- Element -->
  <ng-container *ngIf="element else placeholder">
    <mat-card fxFlex="75">
      <sg2-element-form [element]="element" display="page"></sg2-element-form>
      <hr>
      <sg2-element-form-controls></sg2-element-form-controls>
    </mat-card>

    <div fxFlex="25">
      <!-- <mat-card class="options">
        <h4>{{ 'option' | translate: 'plural' }}</h4>
        <sg2-element-status [element]="element"></sg2-element-status>
        <sg2-element-assign-to [element]="element"></sg2-element-assign-to>
      </mat-card> -->

      <mat-card class="placeholder-log">
        <h4>{{ 'commentandhistory' | translate }}</h4>
        <mat-icon [inline]="true">launch</mat-icon>
        <a (click)="elementSidebarService.open(element, 'logs')">{{ 'historyLogsView' | translate }}</a>
      </mat-card>
    </div>
  </ng-container>

  <!-- Placeholder when no element is found -->
  <ng-template #placeholder>
    <mat-card class="placeholder">
      <h4>{{ 'specificationdoesnotexist' | translate }}</h4>
    </mat-card>
  </ng-template>
  
</div>
